'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPlusRound = function IoPlusRound(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.6 17.5c1.3 0 2.4 1.1 2.4 2.5s-1.1 2.5-2.4 2.5h-10.1v10.1c0 1.3-1.1 2.4-2.5 2.4s-2.5-1.1-2.5-2.4v-10.1h-10.1c-1.3 0-2.4-1.1-2.4-2.5s1.1-2.5 2.4-2.5h10.1v-10.1c0-1.3 1.1-2.4 2.5-2.4s2.5 1.1 2.5 2.4v10.1h10.1z' })
        )
    );
};

exports.default = IoPlusRound;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/plus-round.js
// module id = 2415
// module chunks = 0